import SelectionItem from "../SelectionItem";

import type { TopNDDItemDeps } from "./types";

export default class TopNDropdownItem extends SelectionItem {
    constructor(deps: TopNDDItemDeps) {
        const { id, value, disabledReason } = deps;
        super(`top-${value}`, id, value, disabledReason);
    }

    getSelectedTranslation() {
        return this.getTranslation();
    }

    getTranslation() {
        return {
            key: `si.${this.translationKeyModifier}.options.top-n`,
            replacements: {
                n: this.formatValue(),
            },
        };
    }
}
